<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
            :error-messages="error"
            v-model="isChecked"
        >
          <template #label>
            <div>
              {{ translation(translationList.travel_gdpr_agreement, 'Sunt de acord cu&nbsp;') }}
              <NuxtLink to="/info/privacy-policy" class="text-decoration-none">
                {{
                  translation(translationList.travel_gdpr_agreement_link, ' prelucrarea datelor cu caracter personal')
                }}
              </NuxtLink>
              {{
                translation(translationList.travel_gdpr_agreeement2, '&nbsp;în scopul obținerii de oferte de călătorie.')
              }}
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'TravelGdprAgreement',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-travel-status', {field: 'gdpr_agreement', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-travel', (data) => {
        if (data.detail && data.detail === 'gdpr_agreement') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_travel_gdpr, 'Te rugăm să citești și să accepți termenii și condițiile de prelucrare a datelor cu caracter personal pentru a continua')];
          } else {
            error.value = [];
            emit('validation-travel-status', {field: 'gdpr_agreement', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>